module.exports = __webpack_public_path__ + "img/phone-header.ac586eb5.svg";